import {jsx as $buDqi$jsx} from "react/jsx-runtime";
import "react";
import $buDqi$classnames from "classnames";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $9f10cad1077a3f56$exports = {};

$parcel$export($9f10cad1077a3f56$exports, "SVVButton", () => $9f10cad1077a3f56$export$d4dad59765e2c8bf);
$parcel$export($9f10cad1077a3f56$exports, "SVVButtonLink", () => $9f10cad1077a3f56$export$debe9f21c96841cf);
$parcel$export($9f10cad1077a3f56$exports, "SVVButtonSubmit", () => $9f10cad1077a3f56$export$dcc84e782f858176);
$parcel$export($9f10cad1077a3f56$exports, "SVVButtonReset", () => $9f10cad1077a3f56$export$b2a748f197fb8f6d);
$parcel$export($9f10cad1077a3f56$exports, "SVVButtonCustomType", () => $9f10cad1077a3f56$export$3a36540025e16f9a);
$parcel$export($9f10cad1077a3f56$exports, "SVVButtonCancel", () => $9f10cad1077a3f56$export$a39173738017702b);
$parcel$export($9f10cad1077a3f56$exports, "SVVButtonRow", () => $9f10cad1077a3f56$export$af98fe2bf39ca699);
$parcel$export($9f10cad1077a3f56$exports, "SVVFormButtonRow", () => $9f10cad1077a3f56$export$bb80c33306072f67);



function $9f10cad1077a3f56$var$ButtonInternal(props) {
    const { children: children , small: small = false , color: color = "primary" , disabled: disabled = false , ariaDescribedby: ariaDescribedby , loading: loading , ...restProps } = props;
    const cssClass = (0, $buDqi$classnames)("svv-knapp", {
        "svv-knapp--small": small,
        "svv-knapp--secondary": color === "secondary",
        "svv-knapp--disabled": disabled,
        "svv-knapp--loading": loading
    });
    switch(restProps.buttonType){
        case "href":
            {
                // Fjern buttonType fra restProps for å unngå å rendre denne i DOM-en
                // når vi spreader rest til <Element>
                const { buttonType: // eslint-disable-next-line
                buttonType , href: href , target: target = "_top" , ...rest } = restProps;
                return /*#__PURE__*/ (0, $buDqi$jsx)("a", {
                    className: cssClass,
                    href: href,
                    target: target,
                    "aria-describedby": ariaDescribedby,
                    ...rest,
                    children: children
                });
            }
        case "onClick":
            {
                // Fjern buttonType fra restProps for å unngå å rendre denne i DOM-en
                // når vi spreader rest til <Element>
                const { buttonType: // eslint-disable-next-line
                buttonType , onClick: onClick , ...rest } = restProps;
                return /*#__PURE__*/ (0, $buDqi$jsx)("button", {
                    className: cssClass,
                    onClick: onClick,
                    disabled: disabled,
                    "aria-describedby": ariaDescribedby,
                    type: "button",
                    ...rest,
                    children: children
                });
            }
        case "custom":
            {
                // Fjern buttonType fra restProps for å unngå å rendre denne i DOM-en
                // når vi spreader rest til <Element>
                // eslint-disable-next-line
                const { asElement: asElement , hrefAttribute: hrefAttribute , href: href , buttonType: buttonType , ...rest } = restProps;
                const Element = asElement;
                return /*#__PURE__*/ (0, $buDqi$jsx)(Element, {
                    className: cssClass,
                    "aria-describedby": ariaDescribedby,
                    ...hrefAttribute && href && {
                        [hrefAttribute]: href
                    },
                    ...rest,
                    children: children
                });
            }
        case "cancel":
            {
                const { asElement: asElement = "a" , hrefAttribute: hrefAttribute = "href" , href: href , ariaLabel: ariaLabel , buttonType: // eslint-disable-next-line
                buttonType , ...rest } = restProps;
                const Element = asElement;
                return /*#__PURE__*/ (0, $buDqi$jsx)("div", {
                    className: "cancel-button-container",
                    children: /*#__PURE__*/ (0, $buDqi$jsx)(Element, {
                        "aria-describedby": ariaDescribedby,
                        ...href && {
                            [hrefAttribute]: href
                        },
                        ...rest,
                        "aria-label": ariaLabel,
                        className: "svv-link",
                        children: children
                    })
                });
            }
        default:
            {
                // Fjern buttonType fra restProps for å unngå å rendre denne i DOM-en
                // når vi spreader rest til <Element>
                // eslint-disable-next-line
                const { buttonType: buttonType , ...rest } = restProps;
                return /*#__PURE__*/ (0, $buDqi$jsx)("button", {
                    className: cssClass,
                    type: buttonType,
                    disabled: disabled,
                    "aria-describedby": ariaDescribedby,
                    ...rest,
                    children: children
                });
            }
    }
}
function $9f10cad1077a3f56$export$d4dad59765e2c8bf(props) {
    return /*#__PURE__*/ (0, $buDqi$jsx)($9f10cad1077a3f56$var$ButtonInternal, {
        buttonType: "onClick",
        ...props
    });
}
function $9f10cad1077a3f56$export$debe9f21c96841cf(props) {
    return /*#__PURE__*/ (0, $buDqi$jsx)($9f10cad1077a3f56$var$ButtonInternal, {
        buttonType: "href",
        ...props
    });
}
function $9f10cad1077a3f56$export$dcc84e782f858176(props) {
    return /*#__PURE__*/ (0, $buDqi$jsx)($9f10cad1077a3f56$var$ButtonInternal, {
        buttonType: "submit",
        ...props
    });
}
function $9f10cad1077a3f56$export$b2a748f197fb8f6d(props) {
    return /*#__PURE__*/ (0, $buDqi$jsx)($9f10cad1077a3f56$var$ButtonInternal, {
        buttonType: "reset",
        ...props
    });
}
function $9f10cad1077a3f56$export$3a36540025e16f9a(props) {
    return /*#__PURE__*/ (0, $buDqi$jsx)($9f10cad1077a3f56$var$ButtonInternal, {
        buttonType: "custom",
        ...props
    });
}
function $9f10cad1077a3f56$export$a39173738017702b(props) {
    return /*#__PURE__*/ (0, $buDqi$jsx)($9f10cad1077a3f56$var$ButtonInternal, {
        buttonType: "cancel",
        ...props
    });
}
function $9f10cad1077a3f56$export$af98fe2bf39ca699({ children: children  }) {
    return /*#__PURE__*/ (0, $buDqi$jsx)("div", {
        className: "svv-knapperad",
        children: children
    });
}
function $9f10cad1077a3f56$export$bb80c33306072f67({ children: children  }) {
    return /*#__PURE__*/ (0, $buDqi$jsx)("div", {
        className: "svv-knapperad svv-form-button-row",
        children: children
    });
}




export {$9f10cad1077a3f56$export$d4dad59765e2c8bf as SVVButton, $9f10cad1077a3f56$export$debe9f21c96841cf as SVVButtonLink, $9f10cad1077a3f56$export$dcc84e782f858176 as SVVButtonSubmit, $9f10cad1077a3f56$export$b2a748f197fb8f6d as SVVButtonReset, $9f10cad1077a3f56$export$3a36540025e16f9a as SVVButtonCustomType, $9f10cad1077a3f56$export$a39173738017702b as SVVButtonCancel, $9f10cad1077a3f56$export$af98fe2bf39ca699 as SVVButtonRow, $9f10cad1077a3f56$export$bb80c33306072f67 as SVVFormButtonRow};
//# sourceMappingURL=module.js.map
